// extracted by mini-css-extract-plugin
module.exports = {"chart-type-selector":"C_cF"};